export enum WorkspaceActionTypes {
    API_RESPONSE_SUCCESS = '@@workspace/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR   = '@@workspace/API_RESPONSE_ERROR',

    FETCH_WORKSPACES  = '@@workspace/FETCH_WORKSPACES',
    SWITCH_WORKSPACE  = '@@workspace/SWITCH_WORKSPACE',
    CREATE_WORKSPACE  = '@@workspace/CREATE_WORKSPACE',
    INVITE_MEMBER     = '@@workspace/INVITE_MEMBER',
    FETCH_MEMBERS     = '@@workspace/FETCH_MEMBERS',
    REMOVE_MEMBER     = '@@workspace/REMOVE_MEMBER',
    UPDATE_ROLE       = '@@workspace/UPDATE_ROLE',
    CANCEL_INVITATION = '@@workspace/CANCEL_INVITATION',
    ACCEPT_INVITATION = '@@workspace/ACCEPT_INVITATION',

    RESET             = '@@workspace/RESET',
}
